import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MobileBottomNav from "../mobile/MobileBottomNav";
import MobileHeader from "../mobile/MobileHeader";
import useIsDesktop from "../hooks/useIsDesktop";

export default function AboutUs() {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const { t } = useTranslation();
  const [headerHeight, setHeaderHeight] = useState(112);
  const [search, setSearch] = useState("");

  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  const goSearch = () => {
    if (search.trim() !== "") navigate(`/search?q=${encodeURIComponent(search.trim())}`);
  };

  const story = [
    {
      heading: t("aboutUs.heading1", { defaultValue: "Making Everyday Services Easy" }),
      paragraphs: [
        t("aboutUs.p1_1", { defaultValue: "ShiperBox is a local delivery and home service platform that makes everyday needs simple and convenient." }),
        t("aboutUs.p1_2", { defaultValue: "Instead of visiting different shops or making many phone calls, you can use ShiperBox to order what you need and get it delivered to your doorstep." })
      ],
    },
    {
      heading: t("aboutUs.heading2", { defaultValue: "What We Do" }),
      paragraphs: [
        t("aboutUs.p2_1", { defaultValue: "Fresh Vegetables & Flowers: Order fresh vegetables and flowers for your home, functions, shops, and special occasions." }),
        t("aboutUs.p2_2", { defaultValue: "Professional Garlands: Need a garland for a wedding, festival, pooja, or function? Share your requirements with us and we will arrange and deliver it on time." }),
        t("aboutUs.p2_3", { defaultValue: "One-Day Courier Service: Need to send a package quickly? Our one-day courier service helps you send packages within the city without unnecessary waiting." }),
        t("aboutUs.p2_4", { defaultValue: "Mobile Accessories Delivery: Order mobile accessories such as phone covers, chargers, USB cables, earphones, screen guards, and other useful accessories and get them delivered to your doorstep." }),
        t("aboutUs.p2_5", { defaultValue: "Mobile Home Service: Having a phone problem? Our mobile home service provides selected phone repair services at your home. Depending on the problem, supported services may include screen replacement, battery replacement, charging-port problems, software issues, and other specific phone repairs." })
      ],
    },
    {
      heading: t("aboutUs.heading3", { defaultValue: "Why Choose ShiperBox?" }),
      paragraphs: [
        t("aboutUs.p3_1", { defaultValue: "Simple: Order what you need without visiting multiple shops." }),
        t("aboutUs.p3_2", { defaultValue: "Fast: We focus on quick and reliable delivery." }),
        t("aboutUs.p3_3", { defaultValue: "Local: We work with local vendors and service providers." }),
        t("aboutUs.p3_4", { defaultValue: "Reliable: We keep you informed about your order or service." }),
        t("aboutUs.p3_5", { defaultValue: "Convenient: Get deliveries and selected mobile repair services at your doorstep." })
      ],
    },
    {
      heading: t("aboutUs.heading4", { defaultValue: "Our Goal" }),
      paragraphs: [
        t("aboutUs.p4_1", { defaultValue: "Our goal is simple: make useful local services easier to access." }),
        t("aboutUs.p4_2", { defaultValue: "Whether you need fresh vegetables, flowers, a professional garland, a quick courier, mobile accessories, or a selected mobile repair service at home, ShiperBox is here to help." })
      ],
    },
    {
      heading: t("aboutUs.heading5", { defaultValue: "Thank You" }),
      paragraphs: [
        t("aboutUs.p5_1", { defaultValue: "Thank you for choosing ShiperBox and supporting a local service. We are continuously improving our services based on what our customers need." })
      ],
    },
  ];

  return (
    <div style={{ ...styles.page, ...(isDesktop && styles.pageDesktop) }}>
      <MobileHeader
        searchValue={search}
        setSearchValue={setSearch}
        onSearch={goSearch}
        showLogo={false}
        showTitleBar
        showBackButton={false}
        title={t("aboutUs.title", { defaultValue: "About Us" })}
        isLoggedIn={isLoggedIn}
        onHeightChange={setHeaderHeight}
      />
      
      <div style={isDesktop ? styles.cardDesktop : undefined}>
        <div style={{ ...styles.scrollArea, ...(isDesktop && styles.scrollAreaDesktop), paddingTop: isDesktop ? "24px" : `${headerHeight + 20}px` }}>
          <div style={styles.heroCard}>
            <h1 style={styles.brand}>ShiperBox</h1>
          </div>

          <div style={styles.storyCard}>
            {story.map((block, i) => (
              <div key={i} style={i > 0 ? styles.storyBlock : undefined}>
                <h3 style={styles.storyHeading}>{block.heading}</h3>
                {block.paragraphs.map((p, j) => (
                  <p key={j} style={styles.storyText}>{p}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      {!isDesktop && <MobileBottomNav />}
    </div>
  );
}

const styles = {
  page: { backgroundColor: "#f5f7fa", minHeight: "100vh" },
  pageDesktop: { display: "flex", justifyContent: "center", backgroundColor: "#eef1f5", padding: "40px 20px", boxSizing: "border-box" },
  cardDesktop: { width: "100%", maxWidth: "640px", background: "#fff", borderRadius: "20px", boxShadow: "0 10px 30px rgba(0,0,0,0.08)", overflow: "hidden", height: "fit-content" },
  
  scrollArea: { padding: "0 16px 95px" },
  scrollAreaDesktop: { padding: "24px" },
  heroCard: { background: "#8ec5fc", borderRadius: "18px", padding: "28px 20px", textAlign: "center", marginBottom: "18px", boxShadow: "0 10px 25px rgba(37,99,235,0.25)" },
  brand: { margin: 0, color: "#fff", fontSize: "26px", fontWeight: "800", letterSpacing: "-0.5px" },
  storyCard: { background: "#fff", borderRadius: "16px", padding: "20px 18px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" },
  storyBlock: { marginTop: "18px" },
  storyHeading: { margin: "0 0 8px", fontSize: "15px", color: "#111", fontWeight: "700" },
  storyText: { margin: "0 0 10px", fontSize: "13px", color: "#555", lineHeight: 1.7 },
};